import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFoundOrForbidden = () => {
    const navigate = useNavigate();

    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Result
                status="403"
                title="Access Denied"
                subTitle="You do not have permission to view this page, or the page does not exist."
                extra={
                    <Button type="primary" onClick={() => navigate('/')}>
                        Go Home
                    </Button>
                }
            />
        </div>
    );
};

export default NotFoundOrForbidden;
